import BaseService from '@src/services/BaseService'

class PosPerformanceConfig extends BaseService {
  constructor() {
    super('pos-performance-config')
  }
}

export default new PosPerformanceConfig()
